import axios from 'axios';
import { BASENAME } from './utils/constants/general';

export const API_STATES = {
	PENDING: 'pending',
	LOADING: 'loading',
	SUCCESS: 'success',
	ERROR: 'error'
};

const axiosInstance = axios.create({
	baseURL: BASENAME + '/api',
	headers: {
		'Internal-User-Agent': 'prt.bot.onsemi.com'
	},
	timeout: 120000
});

const api = {
	getCategoryData: categoryApiParam =>
		new Promise(resolve => setTimeout(resolve, 700)).then(() =>
			axiosInstance
				.get(`/data/${categoryApiParam}`)
				.then(response => response.data)
				.catch(e => {
					console.error(e);
					return null;
				})
		),
	getAppVersion: () =>
		axiosInstance
			.get(`/appVersion`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	shouldLogIn: categoryId =>
		axiosInstance
			.get(`/shouldLogIn`, { params: { categoryId } })
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getUserInfo: () =>
		axiosInstance
			.get(`/getUserInfo`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getGatedTaxonomies: () =>
		axiosInstance
			.get(`/getGagedTaxonomies`)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	evalWithWebDesigner: inputApiParam =>
		axiosInstance
			.post(`/evalWithWebDesigner`, inputApiParam)
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			}),
	getGPTResponse: inputApiParam =>
		axiosInstance
			.post(`/getGPTResponse`, {
				request: inputApiParam.request,
				previousComponent: inputApiParam.previousComponent,
				history: inputApiParam.history,
				filterHistory: inputApiParam.usedFilters,
				language: inputApiParam.language
			})
			.then(response => response.data)
			.catch(e => {
				console.error(e);
				return '';
			})
};

export default api;
